import { render } from "./EventosUpload.vue?vue&type=template&id=2cb6b6d1&scoped=true"
import script from "./EventosUpload.vue?vue&type=script&lang=js"
export * from "./EventosUpload.vue?vue&type=script&lang=js"

import "./EventosUpload.vue?vue&type=style&index=0&id=2cb6b6d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb6b6d1"]])

export default __exports__